import { Selector } from "./selectors"

export const InventoryStockDocumentDefinitionSelector = Selector


// WEBPACK FOOTER //
// ./src/state/inventory/stockDocumentDefinition/selectors/index.ts